/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: routes.js
 *  @description: Этот файл является частью клиентской стороны проекта. В этом файле находится описание имеющихся путей в клиентской части приложения и назначенных для этих путей компонентов, занимающихся отображением данных, с разделением по публичным и непубличным путям.
 *	@author: Белов Михаил Александрович, Горбас Александр Петрович, Манжос Геннадий Юрьевич
*/
import {
    EPIDEMICS_ROUTE
} from './utils/consts';

//-----------

import Epidemics_Map_Page from './pages/Epidemics/Epidemics';

//-----------

export const publicRoutes = [
    {
        path: EPIDEMICS_ROUTE,
        Component: Epidemics_Map_Page,
    },
]